import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { useLogger } from '@packages/shared/core/common/hooks';
import { useQuizStep } from '@packages/shared/core/quiz/hooks';
import { ContextPreferenceIntroStepData, QuizScreenProps } from '@packages/shared/core/quiz/entities';
import { getZodiac } from '@packages/shared/core/user/store/selectors';

type ContextPreferenceIntroStepProps = {
  id: string;
  renderQuizScreen: (stepData: QuizScreenProps) => ReactNode;
};

const ContextPreferenceIntroStep = ({ id, renderQuizScreen }: ContextPreferenceIntroStepProps) => {
  const logger = useLogger();

  const { back, next, stepData } = useQuizStep(id);

  const zodiac = useSelector(getZodiac);

  if (!stepData) {
    logger.error(new TypeError(`Data for ${id} step not found`));
    return null;
  }

  const goBack = async () => back();

  const onContinue = async () => {
    await next();
  };

  return (
    <>
      {renderQuizScreen({
        onContinue,
        onBack: goBack,
        zodiac,
        ...(stepData as ContextPreferenceIntroStepData),
      })}
    </>
  );
};

export default ContextPreferenceIntroStep;
